'use strict';
mpangoApp.controller('MuserController', MuserController);  
function MuserController($scope, Mreports,Muser, $window,$http, $auth, $location,$rootScope,$state,$uibModal,Notification,SweetAlert) {
    $scope.isActive = function(route) {
        return route === $location.path();
    };
    $scope.passStatus = 1;
    $scope.checkPass = function(oldpass) {
        Muser.checkPass(oldpass).success(function(data,status) {
            $scope.passStatus = data;
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    };
    $scope.exportDoc = function(tempname,xtype, id) {
        Mreports.toExcel(tempname,xtype,id).success(function  (data,status) {
            var token = $rootScope.sytoken;
            var url = 'index.php/api/toexcel?data='+tempname+'&eId='+id+'&xtype='+xtype+'&token='+token;
            $window.open(url);
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    };
    $scope.sort = function(keywoo){
        $scope.sortKey = keywoo;   
        $scope.reverse = !$scope.reverse; 
    }
    $scope.currentPage = 1;
    $scope.pageSize = 10;
    $scope.pageChangeHandler = function(num){};
    $scope.$on('$viewContentLoaded', function () {
        Muser.getUsers().success(function(data,status) {
            $scope.musers = data.musers;
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    });
    $scope.initEventrole = function() {
        Muser.getUsers().success(function(data,status) {
            $scope.mevents = data.mevents;
            $scope.roles = data.roles;
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    };
    $scope.open = function  (templatename,size) {
        var modalInstance = $uibModal.open({
            templateUrl: templatename,
            keyboard: false,
            backdrop: 'static',
            size: size,
            resolve:{
                musers:function  () {
                    return $scope.musers;
                }
            },
            controller: function  ($scope,musers, $uibModalInstance) {
                $scope.add = function  (userdata,valid) {
                    if (valid == true) {
                        $uibModalInstance.close();
                        angular.extend(userdata,{user_id:$scope.currentUser.id});
                        Muser.postUser(userdata).success(function  (data,status) {
                            $scope.musers = musers;
                            $scope.musers.push(data.insertedD);
                            Notification.success({message: data.message});
                        }).error(function(data,status){
                            $state.go('auth');
                            Notification.error({message: 'Token expired, please login', delay: 3000});
                        }); 
                    };

                    
                }
                $scope.changePass = function  (userdata,valid) {
                    if (valid == true) {
                        $uibModalInstance.close();
                        SweetAlert.swal({
                            title: "Are you sure?",
                            text: "Change your login password",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",confirmButtonText: "Yes!",
                            cancelButtonText: "No, cancel!",
                            closeOnConfirm: true,
                            closeOnCancel: true }, 
                        function(isConfirm){ 
                            if (isConfirm) {
                                Muser.uchangePass(userdata).success(function  (data,status) {
                                    $auth.logout().then(function(){
                                        localStorage.removeItem('user');
                                        $rootScope.authenticated = false;
                                        $rootScope.currentUser = null;
                                        $state.go('auth');
                                    });
                                    Notification.success({message: data.message, delay: 3000});
                                }).error(function(data,status){
                                    $state.go('auth');
                                    Notification.error({message: 'Token expired, please login', delay: 3000});
                                }); 
                           } else {
                              SweetAlert.swal("Cancelled", "Your data is safe!", "error");
                           }
                        });

                    };

                    
                }
                $scope.cancel = function  () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        });
    };
    $scope.update = function(userdata,formname,index) {
        if (formname == 'userupdate') {
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Update user data",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
            function(isConfirm){ 
                if (isConfirm) {
                    Muser.updateUser(userdata,formname).success(function(data) {
                        $state.reload();
                        Notification.success({message: data.message});
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                 
               } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
               }
            });
        };
        if (formname == 'activate') {
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Activate user",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
            function(isConfirm){ 
                if (isConfirm) {
                    Muser.updateUser(userdata,formname).success(function(data) {
                        $state.reload();
                        Notification.success({message: data.message});
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                 
               } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
               }
            });
        };
        if (formname == 'deactivate') {
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Deactivate user",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
            function(isConfirm){ 
                if (isConfirm) {
                    Muser.updateUser(userdata,formname).success(function(data) {
                        $state.reload();
                        Notification.success({message: data.message});
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                 
               } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
               }
            });
        };
        if (formname == 'passreset') {
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Reset user password",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
                function(isConfirm){ 
                if (isConfirm) {
                    Muser.updateUser(userdata,formname).success(function(data) {
                        Notification.success({message: data.message});
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                 
               } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
               }
            });
        };
    };   
    $scope.logout = function() {
        var userdata = 'none';
        var formname = 'usrlogout'
        Muser.updateUser(userdata,formname).success(function(data) {
            $auth.logout().then(function() {

                localStorage.removeItem('user');

                $rootScope.authenticated = false;

                $rootScope.currentUser = null;
                $state.go('auth');
            });
        });        
    }
}
MuserController.$inject = ['$scope', 'Mreports','Muser', '$window','$http', '$auth', '$location','$rootScope','$state','$uibModal','Notification','SweetAlert'];